import { BaseObject } from "./BaseObject.js";

export class RectangleObject extends BaseObject {
  constructor(options = {}) {
    super({
      ...options,
      type: "rectangle",
      tool: options.tool ?? "rectangle"
    });
  }
}
